import request from '@/utils/request'

export const getArticles = (params: any) =>
  request({
    url: '/guide/getGuideInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// export const getArticles = (params: any) =>
//   request({
//     url: '/devicetype/getlistbycondition',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const addEquipment = (params: any) =>
  request({
    url: '/guide/addGuideInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const addEquipment = (params: any) =>
//   request({
//     url: '/devicetype/addDeviceType',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })

export const editForm = (params: any) =>
  request({
    url: `/guide/updateGuideInfo`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const editForm = (params: any) =>
//   request({
//     url: `/devicetype/updateDeviceType`,
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getinfo = (params: any) =>
  request({
    url: `/guide/getGuideInfoById`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })